/**
 * Lets webpack process CSS, SASS or SCSS files referenced in JavaScript files.
 * Those files can contain any CSS code that gets applied to the editor.
 *
 * @see https://www.npmjs.com/package/@wordpress/scripts#using-css
 */
import './editor.scss';

/**
 * React hook that is used to mark the block wrapper element.
 * It provides all the necessary props like the class name.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/packages/packages-block-editor/#useblockprops
 */
import { InspectorControls, useBlockProps } from '@wordpress/block-editor';
import { PanelBody, TextControl, ToggleControl } from '@wordpress/components';

/**
 * Retrieves the translation of text.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/packages/packages-i18n/
 */
import { __ } from '@wordpress/i18n';

/**
 * The edit function describes the structure of your block in the context of the
 * editor. This represents what the editor will render when the block is used.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-edit-save/#edit
 *
 * @return {Element} Element to render.
 */
export default function Edit({ attributes, setAttributes }) {
	const { flightUrl, showTitle, showDate, showMap, flightTitle, flightImage, flightTimeStamp } = attributes; // must correspond to the attributes in block.js

	const handleFlightUrlInputChange = (newValue) => {
		setAttributes({ flightUrl: newValue });
		console.log(newValue);
		wp.ajax.post('traumardr_fetch_data', { 
			url: traumardr_ajax.url,
			_nonce: traumardr_ajax.nonce,
			inputValue: newValue,			
		 })
                .done((response) => {
					console.log(JSON.stringify(response));
					setAttributes({ 
						flightTitle: response.title,
						flightImage: response.image,
						flightTimeStamp: response.fullDate
					 });
                    
                })
                .fail((errorResponse) => {
                });
	}

	const renderBlock = (text, subText) => {
		return (
			<>
				{renderTitle(text)}
				{renderDate(subText)}				
				{renderMap()}
			</>
		);
	}

	const renderTitle = (text) => {
		return (
			<>
			{ ( showTitle ) &&  <p style={{marginBlockStart: '0.7em', marginBlockEnd: '0.1em'}}><a href="#">{text}</a></p> }
			</>
		)
	}

	const renderDate = (text) => {
		return (
			<>
			{ ( showDate ) &&  <p style={{fontSize: '0.7em', marginBlockStart: '0.1em', marginBlockEnd: '1em' }}>{text}</p> }
			</>
		)
	}

	const renderMap = () => {
		return (
			<>
			{ ( showMap ) &&  <a href="#"><img src={mapImageUrl()} style={{width: '100%', height: 'auto'}} /></a> }
			</>
		)
	}

	const mapImageUrl = () => {
		if (flightImage) {
			return flightImage;
		}		
		return traumardr_ajax.mapPlaceHolderUrl;
	}

	const renderNoFlightUrl = () => {		
		if (!flightUrl && !flightTitle) {
			return renderBlock(__('[Vluchtnaam]', 'setting-traumaradar-no-flight-title'), __('Voer een Traumaradar vlucht url in in de instellingen om de vluchtgegevens te tonen.', 'setting-traumaradar-no-flight-url'));
		}
		return null;		
	}

	const renderFlightUrlError = () => {
		if (flightUrl && !flightTitle) {
			return renderBlock(__('[Vluchtnaam]', 'setting-traumaradar-no-flight-title'),__('De url lijkt niet te kloppen. Voeg een vlucht url in van een specifieke vlucht. Bijvoorbeeld: https://traumaradar.nl/vlucht/2024/08/21/97681/lifeliner-2-ph-umc-naar-rotterdam-the-hague-airport.html', 'setting-traumaradar-flight-url-error'));
		}
		return null;		
	}

	const renderFlightUrl = () => {
		if (!flightUrl || !flightTitle) {
			return null; 
		}

		return renderBlock(flightTitle, flightTimeStamp);		
	}

	return (
		<>
		<InspectorControls>
			<PanelBody title={ __( 'Instellingen', 'traumaradar-block' ) }>
				<p>{ __('Zoek de vlucht op ', 'setting-traumaradar-url-explanation-part-1')} <a href="https://traumaradar.nl">traumaradar.nl</a> {__('en kopieer deze in het onderstaande veld.', 'setting-traumaradar-url-explanation-part-2')}</p>
				<TextControl
                    label={ __(
                        'Traumaradar Vlucht Url',
                        'setting-trauma-radar-url'
                    ) }
                    value={ flightUrl || '' }
                    onChange={ ( value ) =>
                        handleFlightUrlInputChange(value)
                    }
					placeholder={ __( 'bijv. https://traumaradar.nl/vlucht/2024/08/21/97681/lifeliner-2-ph-umc-naar-rotterdam-the-hague-airport.html', 'setting-traumaradar-url-placeholder' ) }
                />
				
				<ToggleControl
					checked={ !! showTitle }
					label={ __(
						'Toon titel',
						'setting-show-title'
					) }
					onChange={ () =>
						setAttributes( {
							showTitle: ! showTitle,
						} )
					}
				/>

				<ToggleControl
					checked={ !! showDate }
					label={ __(
						'Toon datum',
						'setting-show-date'
					) }
					onChange={ () =>
						setAttributes( {
							showDate: ! showDate,
						} )
					}
				/>

				<ToggleControl
					checked={ !! showMap }
					label={ __(
						'Toon kaart',
						'setting-show-map'
					) }
					onChange={ () =>
						setAttributes( {
							showMap: ! showMap,
						} )
					}
				/>

				
			</PanelBody>
        </InspectorControls>
		<div { ...useBlockProps() }>
			{renderNoFlightUrl()}
			{renderFlightUrlError()}
			{renderFlightUrl()}
			
		</div>
		</>
	);
}
